var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9999 4.05664V23.8283L15.2492 12.7798L3.9999 4.05664Z",
    fill: "#121E35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5196 16.0608C20.3671 16.1791 20.1835 16.2385 19.9999 16.2385C19.8163 16.2385 19.6326 16.1796 19.4801 16.0608L16.5825 13.814L5.19292 25H34.8069L23.4173 13.814L20.5196 16.0608Z",
    fill: "#121E35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 23.8283V4.05664L24.7506 12.7798L35.9999 23.8283Z",
    fill: "#121E35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6375 3H5.36226L19.9999 14.3511L34.6375 3Z",
    fill: "#121E35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ebb0c5e4d6d349b5635c47d13f269a62.svg";
export { ForwardRef as ReactComponent };